var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceiptSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6654 8.03349V5.1935C13.6654 2.50684 13.0387 1.8335 10.5187 1.8335H5.4787C2.9587 1.8335 2.33203 2.50684 2.33203 5.1935V12.7002C2.33203 14.4735 3.30537 14.8935 4.48537 13.6268L4.49202 13.6202C5.03869 13.0402 5.87202 13.0868 6.34536 13.7202L7.0187 14.6202",
    stroke: "#6F00FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1333 14.7667C13.3115 14.7667 14.2667 13.8115 14.2667 12.6333C14.2667 11.4551 13.3115 10.5 12.1333 10.5C10.9551 10.5 10 11.4551 10 12.6333C10 13.8115 10.9551 14.7667 12.1333 14.7667Z",
    stroke: "#6F00FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 15.1667L14 14.5",
    stroke: "#6F00FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 5.1665H10.6654",
    stroke: "#6F00FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.8335H10",
    stroke: "#6F00FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptSearch);
export default __webpack_public_path__ + "static/media/receipt-search.4e9059f6bce86d24c75f418c0a3e0cf0.svg";
export { ForwardRef as ReactComponent };